<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tJkKFh/tc-custom/9780061925542.jpg?1730580218208" alt="This image is the cover for the book Dream of the Ridiculous Man"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dream of the Ridiculous Man
      </h1>
      <p class="bookDescription body article font2">
        <p>The first-rate collection includes "The Dream of a Ridiculous Man," "Bobok," "The Christmas Tree and the Wedding," and five other short masterpieces. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fyodor Dostoyevsky
      </h2>
      
      <p class="authorDescription body article">Fyodor Dostoyevsky (1821&ndash;1881) was a Russian novelist and philosopher whose works examined the human psyche of the nineteenth century. Dostoyevsky is considered one of the greatest writers in world literature, with titles such as <I>Crime and Punishment</I>;<I> Notes from Underground</I>, one of the first existential novellas ever written; and<I> Poor Folk</I>, Russia&rsquo;s first &ldquo;social novel.&rdquo;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5cb76062